import React from 'react';
import { ThumbsUpIcon, MessageSquareIcon, ShareIcon, UsersIcon } from 'lucide-react';
const GroupFeedWidget = () => {
  return <div className="bg-white rounded-xl border border-gray-200 overflow-hidden" data-id="element-680">
      <div className="p-4 flex justify-between items-center" data-id="element-681">
        <h2 className="text-base font-semibold text-gray-800" data-id="element-682">
          Feed dai Gruppi
        </h2>
        <button className="text-sm text-gray-500 hover:text-gray-700" data-id="element-683">
          Tutti i gruppi
        </button>
      </div>
      <div className="p-4" data-id="element-684">
        <div className="space-y-4" data-id="element-685">
          <FeedItem groupName="Innovatori ESG" authorName="Laura Neri" authorAvatar="https://i.pravatar.cc/150?img=23" time="2 ore fa" content="Ho appena pubblicato un nuovo report sulle strategie di transizione energetica nel settore manifatturiero. Fatemi sapere cosa ne pensate!" likes={24} comments={8} hasImage={true} imageUrl="https://uploadthingy.s3.us-west-1.amazonaws.com/91SHa3uVeGUZjphgY5kVCZ/IMG_0009.jpg" data-id="element-686" />
          <FeedItem groupName="Economia Circolare" authorName="Giovanni Rossi" authorAvatar="https://i.pravatar.cc/150?img=68" time="Ieri" content="Qualcuno ha partecipato al webinar sulla nuova direttiva europea per la plastic tax? Vorrei confrontarmi sui punti principali discussi." likes={12} comments={17} hasImage={false} data-id="element-687" />
        </div>
      </div>
      <div className="px-4 py-3 bg-gray-50 border-t border-gray-200" data-id="element-688">
        <button className="w-full text-sm text-custom-green hover:text-custom-green/90 font-medium" data-id="element-689">
          Visualizza altri post
        </button>
      </div>
    </div>;
};
interface FeedItemProps {
  groupName: string;
  authorName: string;
  authorAvatar: string;
  time: string;
  content: string;
  likes: number;
  comments: number;
  hasImage: boolean;
  imageUrl?: string;
}
const FeedItem: React.FC<FeedItemProps> = ({
  groupName,
  authorName,
  authorAvatar,
  time,
  content,
  likes,
  comments,
  hasImage,
  imageUrl
}) => {
  return <div className="border border-gray-200 rounded-lg p-3" data-id="element-690">
      <div className="flex items-center mb-3" data-id="element-691">
        <div className="w-10 h-10 rounded-full overflow-hidden mr-3" data-id="element-692">
          <img src={authorAvatar} alt={authorName} className="w-full h-full object-cover" data-id="element-693" />
        </div>
        <div data-id="element-694">
          <h3 className="font-medium text-gray-800" data-id="element-695">{authorName}</h3>
          <div className="flex items-center text-xs text-gray-500" data-id="element-696">
            <UsersIcon size={12} className="mr-1" data-id="element-697" />
            <span data-id="element-698">{groupName}</span>
            <span className="mx-1" data-id="element-699">•</span>
            <span data-id="element-700">{time}</span>
          </div>
        </div>
      </div>
      <p className="text-sm text-gray-700 mb-3" data-id="element-701">{content}</p>
      <div className="flex justify-between text-xs text-gray-500" data-id="element-702">
        <div className="flex items-center" data-id="element-703">
          <ThumbsUpIcon size={14} className="mr-1" data-id="element-704" />
          <span data-id="element-705">{likes}</span>
        </div>
        <div data-id="element-706">{comments} commenti</div>
      </div>
      <div className="flex justify-between mt-3 pt-3 border-t border-gray-100" data-id="element-707">
        <button className="flex items-center text-xs text-gray-600 hover:text-gray-800" data-id="element-708">
          <ThumbsUpIcon size={14} className="mr-1" data-id="element-709" />
          Mi Piace
        </button>
        <button className="flex items-center text-xs text-gray-600 hover:text-gray-800" data-id="element-710">
          <MessageSquareIcon size={14} className="mr-1" data-id="element-711" />
          Commenta
        </button>
        <button className="flex items-center text-xs text-gray-600 hover:text-gray-800" data-id="element-712">
          <ShareIcon size={14} className="mr-1" data-id="element-713" />
          Condividi
        </button>
      </div>
    </div>;
};
export default GroupFeedWidget;